import { render, staticRenderFns } from "@/components/Layout/Menu/Gestores/Andina_supermercado/Andina_supermercado.html?vue&type=template&id=c8c5b57a&scoped=true&"
import script from "@/components/Layout/Menu/Gestores/Andina_supermercado/Andina_supermercado.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Gestores/Andina_supermercado/Andina_supermercado.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Gestores/Andina_supermercado/Andina_supermercado.css?vue&type=style&index=0&id=c8c5b57a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c5b57a",
  null
  
)

export default component.exports